/**
 * Como entrar neste ambiente (GET /api/auth/opcoes, pública): login local (desenvolvimento/teste) ou pelo provedor
 * de identidade — no Entra ID (ADR-007), a conta Microsoft 365 da pessoa, com o MFA do HUB como reserva.
 */
import { useEffect, useState } from 'react';
import { chamar } from './api.ts';

export interface OpcoesAutenticacao {
  estrategia: 'local' | 'provedor';
  provedor: 'entra' | 'auth0' | null;
}

let cache: Promise<OpcoesAutenticacao> | undefined;
export function opcoesAutenticacao(): Promise<OpcoesAutenticacao> {
  cache ??= chamar<OpcoesAutenticacao>('GET', '/api/auth/opcoes', undefined, { silencioso: true }).catch((e) => {
    cache = undefined;
    throw e;
  });
  return cache;
}

/** null enquanto carrega. */
export function useOpcoesAutenticacao(): OpcoesAutenticacao | null {
  const [o, setO] = useState<OpcoesAutenticacao | null>(null);
  useEffect(() => {
    let vivo = true;
    opcoesAutenticacao()
      .then((x) => vivo && setO(x))
      .catch(() => vivo && setO({ estrategia: 'local', provedor: null }));
    return () => {
      vivo = false;
    };
  }, []);
  return o;
}

/** Endereço de início do login no provedor, voltando para a tela atual (só caminho relativo; o servidor confere). */
export const urlEntrarNoProvedor = () => `/api/auth/entrar?retorno=${encodeURIComponent(`/${window.location.hash || '#/'}`)}`;
